import React from "react";
import type { ReactNode } from "react";
import { useAuth } from "tecrmi_components/useAuth";
import { setGlobalAccessTokenFn } from "@utils/httpClient";
import { setSearchAccessTokenFn } from "@services/searchApi";
import { LoadingScreen } from "@xplatform/design-system";
import { setAccessToken, clearAccessToken, setAccessTokenRefresher } from "@utils/tokenStore";

interface Props {
  children: ReactNode;
}

export const ModuleContextProvider: React.FC<Props> = ({ children }) => {
  const { getValidAccessToken, currentSession, loading } = useAuth();
  const [tokenReady, setTokenReady] = React.useState(false);

  React.useEffect(() => {
    setGlobalAccessTokenFn(getValidAccessToken);
    setSearchAccessTokenFn(getValidAccessToken);
    setAccessTokenRefresher(getValidAccessToken);
  }, [getValidAccessToken]);

  React.useEffect(() => {
    const storeToken = async () => {
      const token = await getValidAccessToken();
      if (token) {
        setAccessToken(token);
        setTokenReady(true);
      }
    };
    if (currentSession) {
      storeToken();
    } else {
      clearAccessToken();
      setTokenReady(false);
    }
  }, [currentSession, getValidAccessToken]);

  if (loading || (currentSession && !tokenReady)) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  return <>{children}</>;
};
